import { g as getRoomType } from './get-room-type.js';
import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * Swiftbook
 */
const factory = function factory({ window, document, thn }) {
    let refreshPrice = null;
    let refreshSite;
    const roomDetailsParseData = (numAdults, numChildren) => {
        const roomsArray = Array.from(document.querySelectorAll('.prty-bx'));
        if (thn.empty(roomsArray)) {
            return [];
        }
        const roomsInfo = roomsArray.map((room) => {
            const roomName = room.querySelector('.pro-ifo h3')?.textContent?.trim();
            const roomType = getRoomType(roomName);
            const ratesInfo = Array.from(room.querySelectorAll('.prt-dic-otr')).map((rate) => {
                const rateName = rate.querySelector('.info')?.textContent?.trim();
                const ratePrice = thn.parseNumber(rate.querySelector('h5')?.textContent);
                const hasBreakfast = !!rateName?.match(/breakfast|조식|早餐|morgenmad|πρωινό|नाश्ते|sarapan|petit-déjeuner|朝食|café da manhã|завтраком|desayuno|frukost|kahvaltı|าหารเช|bữa sáng|frühstück|وجبة الإفطار/i);
                const isRefundable = true;
                if (!rateName || !ratePrice) {
                    return null;
                }
                return {
                    name: rateName,
                    totalNight: ratePrice,
                    breakfast: hasBreakfast,
                    refundable: isRefundable,
                };
            }).filter((value) => value !== null);
            if (!roomName) {
                return null;
            }
            return {
                name: roomName,
                adults: numAdults || 2,
                children: numChildren || 0,
                type: roomType,
                prices: ratesInfo,
            };
        });
        return roomsInfo.filter((value) => value !== null);
    };
    return {
        onStateChange: thn.debounce(() => {
            thn.pageCheck();
        }, 800),
        generateSearchUrl(ctx) {
            // https://www.swiftbook.io/inst/#home?propertyId=462MzaIVyWR7WDJCLpg2CwcUB1Z4k0MQ==&JDRN=Y&checkIn=2024-05-06&checkOut=2024-05-07&noofrooms=1&adult0=1&child0=0&promoCode=99D&fixp=MjUyMkA5OUQ=
            const url = new URL(ctx.baseUrl);
            const validUrl = url.hostname.match(/swiftbook/);
            if (!validUrl) {
                ctx.newUrl = '';
                return ctx;
            }
            // remove query params
            ctx.newUrl = url.toString();
            return ctx;
        },
        getPromocode(ctx) {
            const manualCodeValue = document.querySelector('.PromoInput')?.value;
            if (manualCodeValue) {
                ctx.promocode = manualCodeValue;
            }
            return ctx;
        },
        languageCheck(ctx) {
            const langDictionary = {
                Spanish: 'es',
                English: 'en',
                Arabic: 'ar',
                Chinese: 'zh',
                Danish: 'da',
                French: 'fr',
                German: 'de',
                Greek: 'el',
                Hindi: 'hi',
                Indonesian: 'id',
                Italian: 'it',
                Japanese: 'ja',
                Korean: 'ko',
                Portuguese: 'pt',
                Russian: 'ru',
                Swedish: 'sv',
                Turkish: 'tr',
                Thai: 'th',
                Vietnamese: 'vi',
            };
            return new Promise((resolve, reject) => {
                const langKeyElement = document.querySelector('#navbarDropdownMenuLink');
                let lang;
                if (langKeyElement) {
                    const langKey = langKeyElement.getAttribute('value') || document.querySelector('.language-Name')?.textContent?.trim();
                    if (langKey && langKey in langDictionary) {
                        lang = langDictionary[langKey];
                    }
                }
                if (lang && ctx.langs.test(lang)) {
                    resolve(lang);
                    return;
                }
                reject(new Error('no_language'));
            });
        },
        boot() {
            const container = document.querySelector('#app');
            if (container) {
                const refreshLanguage = thn.debounce(() => {
                    const isLoading = document.querySelector('.spinner_loader, .spinner');
                    if (!isLoading) {
                        thn.languageCheck().catch(() => { });
                    }
                });
                thn.observeDom(container, refreshLanguage, {
                    childList: true,
                    characterData: true,
                });
                thn.shutdown(() => {
                    refreshLanguage.cancel();
                    thn.stopObserveDom(container, refreshLanguage);
                });
            }
            if (container) {
                refreshSite = thn.debounce(() => {
                    const loader = document.querySelector('.load.two');
                    if (!thn.isVisible(loader)) {
                        thn.pageCheck();
                    }
                }, 600);
                thn.observeDom(container, refreshSite, {
                    attributes: true,
                    childList: true,
                    subtree: true,
                });
                thn.shutdown(() => {
                    if (refreshSite) {
                        refreshSite.cancel();
                        thn.stopObserveDom(container, refreshSite);
                        refreshPrice = null;
                    }
                });
            }
        },
        priceObserveDom(ctx) {
            const container = document.querySelector('#root, .main-bx');
            if (container && !refreshPrice) {
                refreshPrice = thn.debounce(() => {
                    const isLoading = document.querySelector('.spinner_loader, .spinner');
                    if (!isLoading) {
                        ctx.widget.refresh().catch(() => { });
                    }
                }, 500);
                thn.observeDom(container, refreshPrice, {
                    childList: true,
                    subtree: true,
                    attributes: false,
                    characterData: false,
                });
                thn.pageUnload(() => {
                    if (refreshPrice) {
                        refreshPrice.cancel();
                        thn.stopObserveDom(container, refreshPrice);
                        refreshPrice = null;
                    }
                });
            }
        },
        priceParseData() {
            // Guests, Adults & Children
            const guests = document.querySelector('.guestInput input')?.value
                || document.querySelector('.guest-input')?.textContent;
            const guestsMobile = document.querySelectorAll('.quantity');
            const roomAndGuestsArray = guests?.split(',');
            const rooms = thn.parseNumber(roomAndGuestsArray?.[0]);
            const adults = thn.parseNumber(roomAndGuestsArray?.[1] || guestsMobile?.[0]?.value);
            const children = thn.parseNumber(roomAndGuestsArray?.[2] || guestsMobile?.[1]?.value);
            const roomInfo = {
                adults: Number(adults) ?? 2,
                children: Number(children),
                childrenAges: [],
            };
            for (let i = 1; i <= roomInfo.children; i += 1) {
                roomInfo.childrenAges.push(10);
            }
            // Dates
            const dateBeginText = document.querySelector('#start-Date-Input, #CheckIn-Date')?.textContent;
            const dateBegin = (dateBeginText && translateDate(dateBeginText, 'en'))
                || (dateBeginText && dateBeginText.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1'));
            const dateEndText = document.querySelector('#end-Date-Input, #CheckOut-Date')?.textContent;
            const dateEnd = (dateEndText && translateDate(dateEndText, 'en'))
                || (dateEndText && dateEndText.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$3/$2/$1'));
            if (!dateBegin || !dateEnd) {
                return null;
            }
            const nights = thn.daysBetween(dateBegin, dateEnd) ?? 0;
            // Prices & Currency || No Rooms
            let pricesEls;
            if (thn.data.media.name === 'desktop') {
                pricesEls = Array.from(document.querySelectorAll('.origCur, .text-end > h5.notranslate'));
            }
            else {
                pricesEls = Array.from(document.querySelectorAll('.origCur, .new-price'));
            }
            const prices = pricesEls.map((price) => thn.parseNumber(price?.textContent))
                .filter((value) => typeof value !== 'undefined');
            const currency = thn.parseCurrency(pricesEls?.[0]?.textContent);
            const noAvailability = thn.empty(prices);
            const isMultipleRoomSearch = rooms && rooms > 1;
            // no guest info for each room. return when it is multiroom search
            if (isMultipleRoomSearch) {
                return null;
            }
            const price = Math.min(...prices) / nights;
            if (!thn.empty(price) && currency && nights) {
                return {
                    dateBegin,
                    dateEnd,
                    roomsDispo: [roomInfo],
                    roomDetails: roomDetailsParseData(roomInfo.adults, roomInfo.children),
                    price,
                    currency,
                };
            }
            if (noAvailability) {
                return {
                    dateBegin,
                    dateEnd,
                    roomsDispo: [roomInfo],
                    noRooms: true,
                };
            }
            return null;
        },
        bookingParseData() {
            const bookingIdFromDl = thn.dataLayerHelper.get('ecommerce.transaction_id')?.toString();
            const bookingIdFromWindow = window.obj?.bookingid;
            if (!bookingIdFromDl && !bookingIdFromWindow) {
                return {
                    set: false,
                };
            }
            if (bookingIdFromDl) {
                const dateBeginDl = thn.dataLayerHelper.get('checkinDate')?.replace(/-/g, '/');
                const dateEndDl = thn.dataLayerHelper.get('checkoutDate')?.replace(/-/g, '/');
                const priceDl = thn.dataLayerHelper.get('ecommerce.value');
                const currencyDl = thn.dataLayerHelper.get('ecommerce.currency');
                return {
                    bookingId: bookingIdFromDl,
                    dateBegin: dateBeginDl,
                    dateEnd: dateEndDl,
                    price: priceDl,
                    currency: currencyDl,
                };
            }
            const dateBeginWindow = window.obj?.checkIn?.replace(/-/g, '/');
            const dateEndWindow = window.obj?.checkOut?.replace(/-/g, '/');
            const bookingDataArray = window.obj?.data?.split('|') || [];
            const priceText = thn.parseNumber(bookingDataArray.find(item => item.startsWith('BookingAmount:')));
            // The page does not offer any accessible element to obtain the currency.
            return {
                bookingId: bookingIdFromWindow,
                dateBegin: dateBeginWindow,
                dateEnd: dateEndWindow,
                price: priceText,
            };
        },
    };
};

export { factory };
